export default __webpack_public_path__ + "static/media/Q1_0.28bd0a0f.png";